/* eslint-disable */
import cx from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Button, Form, FormGroup, FormControl, ControlLabel, Modal, InputGroup, Radio, InputGroupAddon, HelpBlock } from 'react-bootstrap';
import moment from 'moment';
import { ss } from '../../utils/util';
import Dropzone from 'react-dropzone'

import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import OzPills from './OzPills';
import {
  upload,
} from '../../actions';

import './OzFormComponent.css'


class OzFormComponent extends Component {

  constructor(props) {
    super(props);
    let fields = this.constructor.fields || [];
    let cleaners = this.constructor.cleaners || {};
    let state = {};

    // console.log('FIELDS', fields);
    // console.log('PROPS -> values', this.props.values);

    for (let field of fields) {
      let cleaner = cleaners[field] && cleaners[field].inbound;
      let value = this.props.values[field];
      if (value == undefined) {
        continue;
      }
      if (cleaner == 'date') {
        cleaner = (val) => {
          return moment(val, 'YYYY-MM-DD');
        };
      }
      let cleanValue = cleaner ? cleaner(value) : value;
      state[field] = cleanValue;
    }
    // console.log('Set initial state:', state);
    this.state = state;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log('DID UPDATE', prevState, this.state);
    let prevObj = Object.assign({}, prevState);
    let obj = Object.assign({}, this.state);
    for (let field of (this.constructor.ignoreOnChange || [])) {
      delete prevObj[field];
      delete obj[field];
    }
    let prevValuesStr = JSON.stringify(prevObj);
    let valuesStr = JSON.stringify(obj);
    // console.log('Updated:', valuesStr, prevValuesStr);
    if (this.props.onChange && valuesStr != prevValuesStr) {
      // console.log('Send onChange');
      this.props.onChange(this.getValues());
    }
  }

  getValues() {
    let values = {};
    let fields = this.constructor.fields || [];
    let cleaners = this.constructor.cleaners || {};
    for (let field of fields) {
      console.log('Field:', field);
      let parts = field.split('.');
      let target = values;
      if (parts.length > 1) {
        for (let i = 0; i < parts.length - 1; i++) {
          if (!target[parts[i]]) {
            target[parts[i]] = {};
          }
          target = target[parts[i]];
        }
      }

      let cleaner = cleaners[field] && cleaners[field].outbound;
      let value = this.state[field];

      // console.log('cleaner?', field, cleaner);
      // console.log('GET VALUES', field, value);
      if (value == undefined || value === '') {
        continue;
      }

      if (cleaner == 'date') {
        cleaner = (val) => {
          return val.format('YYYY-MM-DD');
        };
      }

      let cleanValue = cleaner ? cleaner(value) : value;
      target[parts[parts.length - 1]] = cleanValue;
    }
    return values;
  }

  renderErrors(field) {
    if (!this.props.errors) {
      return null;
    }

    let parts = field.split('.');
    let fieldErrors = this.props.errors;

    for (let part of parts) {
      fieldErrors = fieldErrors[part];
      if (!fieldErrors) {
        return null;
      }
    }

    let nodes = [];
    let i = 0;
    for (let error of fieldErrors) {
      nodes.push(<div key={i++}>{error}</div>);
    }
    return <div className={cx('error', field)}>{nodes}</div>;
  }

  renderTextFormGroup(fieldName, placeholder) {
    return (
      <FormControl
        type="text"
        placeholder={placeholder}
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      />
    );
  }

  renderUrlFormGroup(fieldName, placeholder) {
    return (
      <FormControl
        type="url"
        placeholder={placeholder}
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      />
    );
  }

  renderTextAreaFormGroup(fieldName, placeholder) {
    return (
      <FormControl
        componentClass="textarea"
        placeholder={placeholder}
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      />
    );
  }

  renderEmailFormGroup(fieldName, placeholder) {
    return (
      <FormControl
        type="email"
        placeholder={placeholder}
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      />
    );
  }

  renderPasswordFormGroup(fieldName, placeholder) {
    return (
      <FormControl
        type="password"
        placeholder={placeholder}
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      />
    );
  }

  renderSelectFormGroup(fieldName, selectOptions, options) {
    // console.log('renderSelectFormGroup', fieldName, selectOptions);
    let emptyName = (options && options.empty) ? options.empty : '';
    let withEmpty = [['', emptyName]].concat(selectOptions);
    let optGroup = 1;
    // console.log('withEmpty', withEmpty);
    return (
      <FormControl
        componentClass="select"
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      >
        {withEmpty.map(option => {
          if (Array.isArray(option[1])) {
            let options = option[1].map(o => <option key={o[0]} value={o[0]}>{o[1]}</option>);
            return <optgroup key={option[0] + '_' + optGroup++} label={option[0]}>{options}</optgroup>;
          } else {
            return <option key={option[0]} value={option[0]}>{option[1]}</option>;
          }
        })}
      </FormControl>
    );
  }

  renderSelectNumberFormGroup(fieldName, options) {
    let min = options.min;
    let max = options.max;
    let incr = options.incr || 1;

    let opts = [];
    for (let i = min; i <= max; i += incr) {
      let str = i;
      if (options.suffixPlural && i != 1) {
        str += ' ' + options.suffixPlural;
      } else if (options.suffix) {
        str += ' ' + options.suffix;
      }
      opts.push([i, str]);
    }
    return this.renderSelectFormGroup(fieldName, opts, options);
  }

  renderPillsFormGroup(fieldName, options) {
    let handleClick = (idx) => {
      console.log('debug handle click 222', idx, options);
      let delta = {};
      let option = options[idx];
      delta[fieldName] = option[0];
      this.setState(delta);
    }

    let i = 0;
    let nodes = options.map(option => {
      return (
        <div key={'' + option[0]}>{option[1]}</div>
      );
    });

    return (
      <OzPills value={'' + this.state[fieldName]} onClick={(idx) => handleClick(idx)}>
        {nodes}
      </OzPills>
    );
  }

  // renderPillsFormGroup(fieldName, options) {
  //   console.log('debug ?????');
  //   let nodes = options.map(option => {
  //     let delta = {};
  //     delta[fieldName] = option[0];
  //     return (
  //       <div key={option[0]} onClick={() => this.setState(delta)}>{option[1]}</div>
  //     );
  //   });

  //   return (
  //     <OzPills value={this.state[fieldName]}>
  //       {nodes}
  //     </OzPills>
  //   );
  // }

  renderRadioFormGroup(fieldName, options) {
    let setRadioState = (option) => {
      let delta = {};
      delta[fieldName] = option[0];
      this.setState(delta);
    };

    let radioName = fieldName;
    if (this.props.index) {
      radioName += '__' + this.props.index;
    }

    let nodes = options.map(option => {
      return (
        <Radio
          key={option[0]}
          name={radioName}
          onClick={() => setRadioState(option)}
          checked={this.state[fieldName] === option[0]}
          inline
        >
          {option[1]}
        </Radio>
      );
    });

    return (
      <FormGroup>{nodes}</FormGroup>
    );
  }

  renderBooleanFormGroup(fieldName) {
    let options = [
      [true, 'Yes'],
      [false, 'No'],
    ];
    return this.renderRadioFormGroup(fieldName, options)
  }

  renderNumberFormGroup(fieldName, placeholder) {
    return (
      <FormControl
        type="tel"
        placeholder={placeholder}
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      />
    );
  }

  renderCurrencyFormGroup(fieldName, placeholder) {
    return (
      <FormControl
        type="tel"
        placeholder={placeholder}
        value={this.state[fieldName]}
        onChange={ss(this, fieldName)}
      />
    );
  }

  renderCurrency2FormGroup(fieldName, placeholder) {
    return (
      <FormControl
        type="tel"
        value={this.state[fieldName] ? this.state[fieldName].amount : ''}
        placeholder={placeholder}
        onChange={(e) => {
                  let delta = {};
                  delta[fieldName] = { amount: e.target.value, currency: 'CAD' };
                  this.setState(delta);
                 }}
      />
    );
  }

  renderDateFormGroup(fieldName, options={}) {
    let width = Math.max(
      document.documentElement["clientWidth"],
      document.body["scrollWidth"],
      document.documentElement["scrollWidth"],
      document.body["offsetWidth"],
      document.documentElement["offsetWidth"]
    );
    console.log('render date', fieldName, this.state.focused);

    let isOutsideRange;
    if (options.isOutsideRange) {
      isOutsideRange = options.isOutsideRange;
    } else {
      isOutsideRange = (day) => day.isAfter(moment());
    }

    return (
      <div>
        <SingleDatePicker
          date={this.state[fieldName]}
          onDateChange={date => {
                        let d = {};
                        d[fieldName] = date;
                        this.setState(d);
                        if(options.onDateChange) options.onDateChange(d);
                        }}
          focused={this.state.focused}
          onFocusChange={({ focused }) => this.setState({ focused })}
          id={fieldName}
          numberOfMonths={1}
          small={true}
          calendarInfoPosition={options.calendarInfoPosition}
          renderCalendarInfo={options.renderCalendarInfo}
          isOutsideRange={isOutsideRange}
        />
      </div>
    );
  }

  handleReadImage(fieldName, data) {
    this.props.upload({ file: data })
      .then(resp => {
        // console.log('upload complete:', resp);
        let delta = {};
        delta[fieldName] = resp.url
        this.setState(delta);
      });
  }

  readFile(fieldName, file) {
    // console.log('file', file);
    let reader = new FileReader();
    reader.onload = (e) => {
      if (e.target.readyState == 2) {
        this.handleReadImage(fieldName, e.target.result);
      }
    };
    reader.readAsDataURL(file);
  }

  onDrop(fieldName, accepted, rejected) {
    if (!(accepted && accepted.length == 1)) {
      alert('Error with file upload!');
      return;
    }
    let file = accepted[0];
    this.readFile(fieldName, file);
  }

  renderImageFormGroup(fieldName) {
    let url = this.state[fieldName];
    let clearImage = () => {
      let delta = {};
      delta[fieldName] = null;
      this.setState(delta);
    };
    return (
      <div className="image-upload">
        {url && <div>
         <img src={url} />
         <div><Button bsSize="small" onClick={clearImage}>Change</Button></div>
         </div>}
        {!url && <div>
        <input ref="upload" name="upload" type="file" accept="*" onChange={(e) => this.readFile(fieldName, e.target.files[0])}/>
        <Dropzone
          className="drop"
          activeClassName="drop-active"
          acceptClassName="drop-accept"
          onDrop={(a, r) => this.onDrop(fieldName, a, r)}><span>Drag file here to upload</span></Dropzone>
        </div>}
      </div>
    );
  }

  renderFormGroup(prettyName, type, fieldName, options, options2) {
    let placeholder = options ? (options.placeholder || '') : '';
    let helptext;
    if (options && options.helptext) {
      helptext = options.helptext;
    }
    if (options2 && options2.helptext) {
      helptext = options2.helptext;
    }
    return (
      <FormGroup className={fieldName}>
        {prettyName && <ControlLabel>{prettyName}</ControlLabel>}
        {helptext && <HelpBlock>{helptext}</HelpBlock>}
        {type == 'text' && this.renderTextFormGroup(fieldName, placeholder)}
        {type == 'url' && this.renderUrlFormGroup(fieldName, placeholder)}
        {type == 'textarea' && this.renderTextAreaFormGroup(fieldName, placeholder)}
        {type == 'email' && this.renderEmailFormGroup(fieldName, placeholder)}
        {type == 'password' && this.renderPasswordFormGroup(fieldName, placeholder)}
        {type == 'number' && this.renderNumberFormGroup(fieldName, placeholder)}
        {type == 'currency' && this.renderCurrencyFormGroup(fieldName, placeholder)}
        {type == 'currency2' && this.renderCurrency2FormGroup(fieldName, placeholder)}
        {type == 'select' && this.renderSelectFormGroup(fieldName, options, options2)}
        {type == 'selectNumber' && this.renderSelectNumberFormGroup(fieldName, options)}
        {type == 'pills' && this.renderPillsFormGroup(fieldName, options, options2)}
        {type == 'radio' && this.renderRadioFormGroup(fieldName, options)}
        {type == 'date' && this.renderDateFormGroup(fieldName, options)}
        {type == 'image' && this.renderImageFormGroup(fieldName)}
        {type == 'boolean' && this.renderBooleanFormGroup(fieldName)}
        {this.renderErrors(fieldName)}
      </FormGroup>
    );
  }

  renderFormGroupPair(one, two) {
    return (
      <div className="two">
        <div className="cell">
          {this.renderFormGroup(one[0], one[1], one[2], one[3])}
        </div>
        <div className="cell">
          {this.renderFormGroup(two[0], two[1], two[2], two[3])}
        </div>
      </div>
    );
  }

  addMany(fieldName, values={}) {
    console.log('add many', fieldName);
    if (!this.nextIndexes) {
      this.nextIndexes = {}
    }
    if (!this.nextIndexes[fieldName]) {
      this.nextIndexes[fieldName] = 0;
    }
    let id = 'new_' + this.nextIndexes[fieldName]++;

    let updated = [];
    let existing = this.state[fieldName];
    if (existing) {
      updated = updated.concat(existing);
    }
    let init = Object.assign({}, this.options[fieldName].init, values);
    init.id = id;
    updated.push(init);
    let delta = {};
    delta[fieldName] = updated;
    console.log('delta', delta);
    this.setState(delta);
  }

  removeMany(id, fieldName) {
    let updated = [];
    for (let i = 0; i < this.state[fieldName].length; i++) {
      let item = this.state[fieldName][i];
      if (item.id != id) {
        updated.push(item);
      }
    }
    let delta = {};
    delta[fieldName] = updated;
    this.setState(delta);
  }

  updateMany(id, values, fieldName) {
    // console.log('---> update many:', id, values, this.state);
    let existing = this.state[fieldName] || []
    let updated = [].concat(existing);
    let didUpdate = false;
    for (let i = 0; i < existing.length; i++) {
      let pl = this.state[fieldName][i];
      if (pl.id == id) {
        updated[i] = values;
        updated[i].id = id;
        didUpdate = true;
      }
    }
    if (!didUpdate) {
      let newItem = Object.assign({}, values);
      newItem.id = id;
      updated.push(newItem);
    }
    let delta = {};
    delta[fieldName] = updated;
    // console.log('==> updated:', fieldName, updated, delta);
    this.setState(delta);
  }

  submit(e) {
    e.preventDefault();
    if (this.props.disabled) return;
    this.props.onSubmit(e, this.getValues());
  }

  renderButtons() {
    return (
      <FormGroup className="oz-form-buttons">
        {this.props.cancelText && <Button bsSize="lg" bsStyle="default" onClick={(e) => this.props.onCancel(e)}>{this.props.cancelText}</Button>}{' '}
        {this.props.cancelRender && <div onClick={(e) => this.props.onCancel(e)}>{this.props.cancelRender()}</div>}{' '}
        {this.props.buttonText && <Button bsSize="lg" bsStyle="primary" type="submit" disabled={this.props.disabled}>{this.state.buttonText || this.props.buttonText}</Button>}{' '}
      </FormGroup>
    );
  }

  render() {
    // console.log(this);

    let cssClass = 'Wrapper';

    let body = this.renderBody();
    let buttons = !this.props.hideButtons && this.renderButtons();
    if (this.props.modal) {
      body = <Modal.Body>{body}</Modal.Body>;
      buttons = <Modal.Footer>{buttons}</Modal.Footer>;
    }
    if (this.props.rowPart) {
      return body;
    } else if (this.props.part) {
      return <div className={cssClass}>{body}{buttons}</div>;
    }
    return (
      <Form className="OzFormComponent" onSubmit={(e) => this.submit(e)}>
        {this.renderErrors('nonFieldErrors')}
        {body}
        {!this.props.hideButtons && buttons}
      </Form>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    upload: (...args) => dispatch(upload(...args)),
  }
}

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(OzFormComponent);

export default OzFormComponent;



/** WEBPACK FOOTER **
 ** ./src/components/partials/OzFormComponent.js
 **/